import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CancelScheduledPushNotificationUseCaseInterface } from 'domain/usecases';

export class RemoteCancelScheduledPushNotification
  implements CancelScheduledPushNotificationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: CancelScheduledPushNotificationUseCaseInterface.Params,
  ): Promise<CancelScheduledPushNotificationUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${params.id}`,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
